<template>
  <div class="">
    <div class="ZjZR4FiYzgfJQbE3_Etq">
      <datetimePicker
        class="ifzwCQu8BPs2c24nZdzQ"
        @_timeOnFunEndDate="_timeOnFunEndDate"
      ></datetimePicker>
      <div class="">
        <searchFor
          @search="_search"
          @input="_searchInput"
          :placeholder="$t('promote._IDdeMembro')"
        ></searchFor>
      </div>
    </div>
    <div class="TBtGFT5INIot5sEUIm8w vantDataList">
      <van-list
        v-if="fromList && fromList.length"
        :finished="finished"
        v-model="loading"
        @load="onLoad"
      >
        <div
          slot="default"
          v-for="(item, index) in fromList"
          :key="index"
          :title="item"
        >
          <van-row type="flex" justify="space-between">
            <van-col span="12">
              <div class="Iu2XDEUxSXVTmZ2ClDl5">
                <div class="s-s" @click="copyContent(item.id)">
                  {{ item.id }}
                  <svg-icon icon-class="comm_icon_copy--svgSprite:all" />
                </div>
                <div class="dG0FpGdkHU5MgpFCLljd globalVipLevel">
                  <p class="TmCsEwuUw4tM7cplmM6W">{{ item.vip }}</p>
                </div>
              </div>
            </van-col>
            <van-col span="12">
              <label>{{ $t('promote._ApostasVálidas') }}</label
              ><span class="currencyAmount"> {{ item.bet_total }}</span>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between">
            <van-col span="12">
              <span class="dateTime">{{ item.reg_time }}</span>
            </van-col>
            <van-col span="12">
              <label>{{ $t('_VIP._Depósito') }}</label>
              <span class="currencyAmount">
                {{ item.recharge_total }}
              </span>
            </van-col>
          </van-row>
        </div>
      </van-list>
      <van-empty
        image-size="2.1rem"
        v-if="!fromList || !fromList.length"
        class="custom-image"
        :image="img_none_sj"
        :description="$t('description')"
      />
      <div class="nVAOZ5L2ZIX7FtNLSqAD" v-if="1 || showTotal">
        <div
          class="PzFW1R_NxciR5KCVuKck"
          :class="{
            kAaqfTc5guezIg4i8OHU: !isTanzhans
          }"
        >
          <div class="L7qtNTcvxkLyv8NTsUx8" @click="isTanzhans = !isTanzhans">
            <!-- ED6sIMJuJEuPpvzsMw30 -->
            <svg-icon
              class="dPPYvWfEoY8BG3Qg86dU"
              :class="{
                ED6sIMJuJEuPpvzsMw30: !isTanzhans
              }"
              icon-class="img_jt_ss--svgSprite:all"
            />
          </div>
          <van-row
            type="flex"
            class="WKP0P703NvX8zzUuEJg9"
            justify="space-between"
          >
            <van-col span="12">
              <label>Número de pessoas convidadas</label>
              <span class="currencyAmount">{{ shareInfo.invite }}</span>
            </van-col>
            <van-col span="12">
              <label>Número total de recargas</label>
              <div class="customNormal">
                <span> {{ shareInfo.recharge_num }}</span>
              </div>
            </van-col>
            <van-col span="12">
              <label>Depositantes válidos</label>
              <span class="currencyAmount">{{ shareInfo.first_recharge }}</span>
            </van-col>
            <van-col span="12">
              <label>Depósito total</label>
              <div class="customNormal">
                <span> {{ shareInfo.recharge_total }}</span>
              </div>
            </van-col>
            <van-col span="12">
              <label>Aposta total</label>
              <span class="currencyAmount">{{ shareInfo.bet_total }}</span>
            </van-col>
            <van-col span="12">
              <label>Comissão total</label>
              <div class="customNormal">
                <span> {{ shareInfo.get_bonus }}</span>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from '@/components/searchFor/datetimePicker.vue';
import searchFor from '@/components/searchFor/searchFor.vue';
// allData
import { shareAllDataA7 } from '@/apis/modules/share.js';
export default {
  name: 'vip',
  components: {
    datetimePicker,
    searchFor
  },

  data() {
    return {
      list: [],
      isTanzhans: false,
      loading: false,
      finished: false,
      shareInfo: {},
      shareTime: 'Ontem',
      active: 0,
      fromList: [],
      showTotal: false,
      fromType: 1,
      formData: {
        start_time: '',
        end_time: '',
        search_id: '' //搜索下级ID
      }
    };
  },
  mounted() {
    this.shareAllData();
  },
  methods: {
    _timeOnFunEndDate(Tim, anD) {
      this.fromList = [];
      this.finished = false;
      this.fromType = 1;
      this.formData.start_time = Tim;
      this.formData.end_time = anD;
      this.shareAllData();
    },
    _search(e) {
      this.fromList = [];
      this.fromType = 1;
      this.finished = false;
      this.formData.search_id = e;
      this.shareAllData();
    },
    _searchInput(e) {
      this.formData.search_id = e.target.value;
    },
    onLoad() {
      if (this.finished) {
        return false;
      }

      this.fromType = this.fromType + 1;
      this.shareAllData();
    },
    shareAllData() {
      shareAllDataA7({
        ...this.formData,
        level: 2,
        page: this.fromType
      }).then(({ data }) => {
        let { list } = data;
        if (JSON.stringify(list) == '[]' || list.length < 50) {
          this.finished = true;
        }
        this.loading = false;
        if (this.fromType == 1) {
          this.shareInfo = data;
        }
        this.showTotal = data.show_total;
        this.fromList = [...this.fromList, ...data.list];
      });
    },
    tabIndexTime(index, time) {
      this.shareTime = time;
      this.active = index;
      this.shareMyData();
    }
  }
};
</script>
<style></style>
<style scoped>
.nVAOZ5L2ZIX7FtNLSqAD {
  min-height: 0.4rem;
  position: relative;
  width: 100%;
}

.nVAOZ5L2ZIX7FtNLSqAD .PzFW1R_NxciR5KCVuKck {
  background-color: var(--theme-main-bg-color);
  border-top: 0.01rem solid var(--theme-color-line);
  bottom: 0;
  font-size: 0.2rem;
  line-height: 0.22rem;
  padding: 0.2rem 0.2rem 0;
  position: fixed;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  width: 100%;
}

.nVAOZ5L2ZIX7FtNLSqAD .PzFW1R_NxciR5KCVuKck.kAaqfTc5guezIg4i8OHU {
  -webkit-transform: translateY(calc(100% - 0.6rem));
  transform: translateY(calc(100% - 0.6rem));
}

.nVAOZ5L2ZIX7FtNLSqAD .PzFW1R_NxciR5KCVuKck .WKP0P703NvX8zzUuEJg9 {
  font-size: 0.2rem;
}

.nVAOZ5L2ZIX7FtNLSqAD .PzFW1R_NxciR5KCVuKck .WKP0P703NvX8zzUuEJg9 .van-col {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 0.15rem;
}

.nVAOZ5L2ZIX7FtNLSqAD
  .PzFW1R_NxciR5KCVuKck
  .WKP0P703NvX8zzUuEJg9
  .van-col
  label {
  color: var(--theme-text-color-lighten);
  margin-right: 0.1rem;
  width: 50%;
}

.nVAOZ5L2ZIX7FtNLSqAD .PzFW1R_NxciR5KCVuKck .L7qtNTcvxkLyv8NTsUx8 {
  -ms-flex-align: self-start;
  -ms-flex-pack: center;
  align-items: self-start;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.5rem 0.5rem 0 0;
  border-top: 0.02rem solid var(--theme-color-line);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: var(--theme-primary-color);
  display: -ms-flexbox;
  display: flex;
  height: 0.35rem;
  justify-content: center;
  left: 50%;
  padding: 0.1rem;
  position: absolute;
  top: 0;
  -webkit-transform: translate(-50%, -98%);
  transform: translate(-50%, -98%);
  width: 0.7rem;
}

.nVAOZ5L2ZIX7FtNLSqAD
  .PzFW1R_NxciR5KCVuKck
  .L7qtNTcvxkLyv8NTsUx8
  .dPPYvWfEoY8BG3Qg86dU {
  font-size: 0.2rem;
  width: 0.2rem;
  height: 0.2rem;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.nVAOZ5L2ZIX7FtNLSqAD
  .PzFW1R_NxciR5KCVuKck
  .L7qtNTcvxkLyv8NTsUx8
  .dPPYvWfEoY8BG3Qg86dU.ED6sIMJuJEuPpvzsMw30 {
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
.ZjZR4FiYzgfJQbE3_Etq {
  padding: 0.2rem;
}

.ZjZR4FiYzgfJQbE3_Etq {
  -ms-flex-align: center;
  -ms-flex-pack: start;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0.2rem;
}

.ifzwCQu8BPs2c24nZdzQ {
  margin-right: 0.2rem;
}

.dG0FpGdkHU5MgpFCLljd {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: #c12929;
  border-radius: 0.04rem 0 0.04rem 0;
  display: -ms-flexbox;
  display: flex;
  height: 0.23rem;
  justify-content: center;
  left: 0;
  line-height: 1;
  position: absolute;
  top: 0;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  width: 0.3rem;
}

.dG0FpGdkHU5MgpFCLljd .TmCsEwuUw4tM7cplmM6W {
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(-5%, #f7ea94),
    color-stop(58%, #e5b952),
    color-stop(114%, #ce9510)
  );
  background-image: linear-gradient(
    180deg,
    #f7ea94 -5%,
    #e5b952 58%,
    #ce9510 114%
  );
  font-size: 0.16rem;
  font-weight: 700;
  line-height: 1;
}

.vantDataList .van-list > div {
  color: var(--theme-text-color-darken);
  font-size: 0.2rem !important;
  position: relative;
}

.Iu2XDEUxSXVTmZ2ClDl5 .s-s svg {
  font-size: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
  margin-left: 0.1rem;
  color: var(--theme-primary-color);
  position: relative;
}

.vantDataList .van-list > div label {
  color: var(--theme-text-color-lighten);
  margin-right: 0.1rem;
}

.vantDataList .van-list .van-col {
  margin-bottom: 0.05rem;
}

.dateTime {
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
}

.zhMFiMGv4SkVVrKaizPg .dateTime {
  font-size: 0.2rem !important;
}
</style>
